module.exports = {
          srcSet: __webpack_public_path__ + "images/1914-6802dd9f2c6b35fe169a69278d7e5001-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1914-9278b9e3c4024c0925d2cfe3d778985a-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1914-6802dd9f2c6b35fe169a69278d7e5001-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1914-9278b9e3c4024c0925d2cfe3d778985a-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1914-6802dd9f2c6b35fe169a69278d7e5001-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1914-6802dd9f2c6b35fe169a69278d7e5001-320.jpg"},
          
          width: 320,
          height: 251
        }